module.exports = "/static-assets/_next/static/images/dumbbell-470f33f71940d1c8498e4273cf545ab8.png";